module.exports = __webpack_public_path__ + "img/celebrate.182b4568.png";